import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { OperationAccounts } from 'legacy/FVAdminPanel/TenantConfig/views/OperationAccounts';
import { Stack } from 'xen-ui';
import { useFeatureFlags } from 'xen/hooks';
import { ConfigurationsWrapper } from '../components/configurations-wrapper';
import { FactoringImportWizard } from '../components/factoring/import-wizard';
const Factoring = () => {
    const { demoware } = useFeatureFlags();
    return (_jsx(ConfigurationsWrapper, { activeTab: "factoring", children: _jsxs(Stack, { gap: "lg", children: [_jsx(OperationAccounts, {}), demoware && _jsx(FactoringImportWizard, {})] }) }));
};
export default Factoring;
